<!--
    秒杀组件 类型3 两列 右边上下分布
-->

<template>
  <div class="seckill-3" @click="edit">
    <di id="point_wrapper" v>
      <el-row>
        <el-col :span="12">
          <div class="s-3-header">
            <div><span>限时秒杀</span><span>更多》</span></div>
            <p>
              <span class="time">05</span>
              <span>时</span>
              <span class="time">06</span>
              <span>分</span>
              <span class="time">60</span>
              <span>秒</span>
            </p>
          </div>
          <div class="s-3-left">
            <img :src="defaultImg" alt="" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="s-3-right">
            <img :src="defaultImg" alt="" />
            <img :src="defaultImg" alt="" />
          </div>
        </el-col>
      </el-row>
    </di>
  </div>
</template>

<script>
export default {
  props: {
    cptData: {
      type: Object,
      default: {
        componentName: 'seckill_1',
        selectStatus: false,
        data: {}
      }
    }
  },
  data() {
    return {
      defaultImg: require('@/asset/icon/saoma@2x.png')
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style lang="less" scoped>
@import './com.less';
.seckill-3 {
  padding: 10px 5px;
  background-color: @color-background;

  &:hover {
    cursor: pointer;
    box-shadow: 0 0 2px @color-border;
  }

  & > div {
    font-size: 14px;
    .s-3-header {
      padding: 0 10px 10px;
      & > div {
        margin-bottom: 10px;
      }
      p {
        display: inline-block;

        span {
          display: inline-block;
          width: 18px;
          height: 18px;
        }
        .time {
          background-color: rgba(000, 000, 000, 0.8);
          color: @color-background;
        }
      }
      span:last-of-type {
        float: right;
      }
    }
    .s-3-left,
    .s-3-right {
      text-align: center;
      img {
        width: 90%;
      }
    }
    .s-3-left {
      text-align: center;
      img {
        height: 225px;
      }
    }
  }
}
</style>
